export enum DataOperationType {
  None = 0,
  Create,
  Open,
  Compose,
  Delete,
  UpdateViews,
  AddModel
}